import styled from 'styled-components';

export const CardLine = styled.div`
  min-height: 3px;
  width: 63px;
  background-color: ${({ theme }) => theme.colors.orange};
`;
